<script setup>
import { useSurveyPopup } from "@/composables/useSurveyPopup"

const {
  closeSurvey,
  deferSurveyAndClose,
  isRequiredSurveyQuestion,
  isVisible,
  questionAnswer,
  saveSurvey,
  scoreOptions,
  surveyQuestions,
} = useSurveyPopup()
</script>

<template>
  <Teleport to="#modal">
    <div class="popup-wrap popup-survey" v-if="isVisible">
      <div class="dim-bg"></div>
      <div class="popup">
        <a href="#!" class="btn-close pop-close">
          <img src="/imgs/common/ico_popup_close.svg" alt="닫기" @click="closeSurvey">
        </a>
        <p class="header">만족도 평가</p>
        <div class="content">
          <div class="survey-list">
            <dl v-for="(question, index) in surveyQuestions" :key="question.questionCode || question.questionOrder">
              <dt>
                <strong v-if="question.questionType === '주관식'">※</strong>
                <strong v-else>{{ question.questionOrder + "." }}</strong>
                {{ question.question }}
              </dt>
              <dd v-if="question.questionType === '객관식'">
                <div class="radio" v-for="score in scoreOptions" :key="score">
                  <input
                    type="radio"
                    :name="'surveyList0' + question.questionOrder"
                    :id="'list0' + question.questionOrder + '_answer' + score"
                    v-model="questionAnswer[index]"
                    :value="score.toString()"
                  >
                  <label :for="'list0' + question.questionOrder + '_answer' + score">{{ score }}점</label>
                </div>
              </dd>
              <dd v-else>
                <textarea rows="4" v-model="questionAnswer[index]"></textarea>
              </dd>
            </dl>
          </div>
        </div>
        <div class="btn-wrap">
          <a href="#!" class="btn size-m line" @click="deferSurveyAndClose">다음에 하기</a>
          <a href="#!" class="btn size-m type01" @click="saveSurvey">제출하기</a>
        </div>
      </div>
    </div>
  </Teleport>
</template>
